var organisationButton = {
    base: {
        p: 5,
        maxWidth: "100%",
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        cursor: "pointer",
        gap: 4,
        ":hover": {
            backgroundColor: "primary.5",
        },
    },
};

export { organisationButton };
//# sourceMappingURL=organisation-button.js.map
